// Feature flags — client decision (observations 27-oct-2026): the e-commerce
// STRUCTURE stays in the codebase for a future launch, but favorites and
// order requests must NOT be visible on the public site for now.
// Flip a flag to true and the feature returns everywhere instantly.
export const FEATURES = {
  favorites: false,
  orderRequests: false,
};
